import { APIRoute } from '@/modules/utils'

export type Response = never
export type Body = never

export type UrlParams = {
  animalId: string
}

export const Route: APIRoute = {
  method: 'DELETE',
  path: `/acquisition/members/petowners/animals/:animalId`,
}
